import { css } from '@emotion/core';
import { tokens, applyFont } from '@domain-group/fe-brary';
var typography = tokens.typography;
var ellipsisDetails = {
  name: "9y42th",
  styles: "width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"
};
export var address = /*#__PURE__*/css(applyFont(typography.body), ";");
export var addressLine = /*#__PURE__*/css(ellipsisDetails, " max-width:200px;[data-new-dev-layout='three-column'] &{display:inline;max-width:none;}");